var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function OpenNewTabIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M19 6.41421L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L17.5858 5H15C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3H20C20.5523 3 21 3.44772 21 4V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V6.41421ZM19 13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V19.0025C21 20.1067 20.1063 21 19.0001 21H4.99985C3.89485 21 3 20.1068 3 19.0001V4.99985C3 3.89582 3.89357 3 4.99754 3H11C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H5V19H19V13Z", fill: "" })));
}
export var OpenNewTabIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: OpenNewTabIconInner }, props))); };
//# sourceMappingURL=OpenNewTabIcon.js.map